// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Record_spinnerContainer__9xcW1","recordContainer":"Record_recordContainer__p8EDs","loader":"Record_loader__XV+se","spin":"Record_spin__e+U5x"};